import { render } from "./AccountantAffected.vue?vue&type=template&id=54d82421"
import script from "./AccountantAffected.vue?vue&type=script&lang=js"
export * from "./AccountantAffected.vue?vue&type=script&lang=js"

import "./AccountantAffected.vue?vue&type=style&index=0&id=54d82421&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__